export default __webpack_public_path__ + "static/media/nft-video.7292888f.mp4";